import { atom } from 'jotai';

/**
 * Assets uploaded via the FileSpin picker that have not yet appeared in the
 * backend search index. The Dashboard prepends these as "Processing"
 * placeholders and polls the search query until they show up (or expire).
 */
export type PendingUpload = {
  id: string;
  name: string;
  contentType: string;
  size?: number;
  addedAt: number;
};

export const pendingUploadsAtom = atom<PendingUpload[]>([]);

/**
 * The most recent upload batch, kept for the post-upload AI Agent nudge.
 *
 * Deliberately separate from `pendingUploadsAtom`: that list is emptied the
 * moment the search index catches up — i.e. exactly when the nudge becomes
 * useful — whereas this survives until the user acts on it, dismisses it, or
 * it ages out.
 */
export type LastUpload = {
  ids: string[];
  at: number;
};

export const lastUploadAtom = atom<LastUpload | null>(null);

/** How long the post-upload nudge stays offered. */
export const LAST_UPLOAD_TTL_MS = 5 * 60 * 1000;
